/* @flow */

import validatorjs from 'validatorjs';

import MobxReactForm from 'mobx-react-form';

import hooks from './_.hooks';

import dvrExtend from './validation/dvr';

export default class Form extends MobxReactForm {
  constructor(...args: Array<Object>) {
    if (!args.options) {
      args.options = {
        // defaultGenericError: 'Invalid Data',
        validateOnInit: false,
        // showErrorsOnInit: false,
        // autoParseNumbers: true
      };
    }

    super(...args);
  }

  // eslint-disable-next-line
  // bindings() {
  //     return bindings;
  // }

  // eslint-disable-next-line
  hooks() {
    return hooks;
  }

  // eslint-disable-next-line
  plugins() {
    return {
      dvr: {
        package: validatorjs,
        extend: dvrExtend,
      },
    };
  }
}
